<template>
  <div
    class="wl-empty-state flex flex-col items-center rounded-2xl p-4"
    :class="{
      'is-boxed bg-muted': isBoxed,
    }"
  >
    <WLIcon
      ref="iconRef"
      class="mb-2 animate-spin"
      :name="IconName.NAVIGATION_LOADING"
    />
    <p
      v-if="title"
      ref="titleRef"
      class="mb-0.5 text-center font-medium text-emphasis"
      :class="{ 'text-sm': variant === LoadingStateVariant.INLINE }"
    >
      {{ title }}
    </p>
    <p
      v-if="subTitle"
      ref="subTitleRef"
      class="text-center text-sm font-normal text-muted"
    >
      {{ subTitle }}
    </p>
    <WLButton
      v-if="buttonLabel"
      :size="ButtonSize.EXTRA_SMALL"
      class="mt-6"
      @click="emit('buttonClick', $event)"
    >
      {{ buttonLabel }}
    </WLButton>
  </div>
</template>
<script setup lang="ts">
import { toRefs } from "vue";
import { IconName, WLIcon } from "../icon";
import { ButtonSize, WLButton } from "../button";
import {
  LoadingStateVariant,
  type LoadingStateEmits,
  type LoadingStateProps,
} from "./types";

const props = withDefaults(defineProps<LoadingStateProps>(), {
  isBoxed: false,
  variant: LoadingStateVariant.INLINE,
});

const { isBoxed, title, subTitle, buttonLabel } = toRefs(props);

const emit = defineEmits<LoadingStateEmits>();
</script>
